import Axios from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";

interface TemplateResponse {
  residentialTemplateUrl: string;
}

export function useRZRestrictionsWeightsTemplate(zoneId: number | string) {
  async function queryFn(): Promise<TemplateResponse> {
    const url = `/planning-api/residentialzones/${zoneId}/templates`;
    const result = await Axios.get(url);
    return result.data;
  }
  return useQuery(baseDataKeys.templates, queryFn);
}
